export default function isDate(
  value: Date | null | string | undefined
): boolean {
  if (!value) {
    return false
  }
  try {
    const date = new Date(value)
    return !Number.isNaN(date.getTime())
  } catch (error) {
    return false
  }
}
